import { PropertyActivityItem, PropertyActivityPtoType, PropertyActivityType } from 'Modules'

import { PTOTypeEnum } from './pto'

/**
 * BE populates `typeId` as an object on GET but expects a string on POST/PUT.
 * Use these helpers to read the id / name regardless of which form is given.
 */
export const getActivityTypeId = (
  activity: PropertyActivityItem | null | undefined
): string | undefined => {
  if (!activity) return undefined
  const t = activity.typeId
  return typeof t === 'string' ? t : t?._id
}

export const getActivityTypeName = (
  activity: PropertyActivityItem | null | undefined
): string | undefined => {
  if (!activity) return undefined
  const t = activity.typeId
  return typeof t === 'object' ? (t as PropertyActivityType).name : undefined
}

export const getActivityTypeIcon = (
  activity: PropertyActivityItem | null | undefined
): string | undefined => {
  if (!activity) return undefined
  const t = activity.typeId
  return typeof t === 'object' ? (t as PropertyActivityType).icon : undefined
}

export const PROPERTY_ACTIVITY_LIMITS = {
  MAX_IMAGES: 6,
  MAX_DOCUMENTS: 6,
  MAX_UPLOAD_FILE_SIZE_MB: 10,
  MAX_ICON_SIZE_MB: 2,
  TITLE_MAX: 255,
  DESCRIPTION_MAX: 2000,
}

export const PROPERTY_ACTIVITY_PTO_TYPE_LABEL: Record<PropertyActivityPtoType, string> = {
  [PTOTypeEnum.PTO]: 'PTO',
  [PTOTypeEnum.RENTAL_PTO]: 'Rental PTO',
}

export const PROPERTY_ACTIVITY_PTO_TYPE_FILTER_OPTIONS: {
  label: string
  value: PropertyActivityPtoType | 'ALL'
}[] = [
  { label: 'All Types', value: 'ALL' },
  { label: PROPERTY_ACTIVITY_PTO_TYPE_LABEL[PTOTypeEnum.PTO], value: PTOTypeEnum.PTO },
  {
    label: PROPERTY_ACTIVITY_PTO_TYPE_LABEL[PTOTypeEnum.RENTAL_PTO],
    value: PTOTypeEnum.RENTAL_PTO,
  },
]

// NOTE: BE chưa support status (Draft/Published) — sẽ bổ sung sau.
// Khi BE ready, uncomment các options + status filter trong UI.
//
// import { PropertyActivityStatus } from 'Modules'
// export const PROPERTY_ACTIVITY_STATUS_LABEL: Record<PropertyActivityStatus, string> = {
//   PUBLISHED: 'Published',
//   DRAFT: 'Draft',
// }
//
// export const PROPERTY_ACTIVITY_STATUS_FILTER_OPTIONS: {
//   label: string
//   value: PropertyActivityStatus | 'ALL'
// }[] = [
//   { label: 'All Status', value: 'ALL' },
//   { label: 'Published', value: 'PUBLISHED' },
//   { label: 'Draft', value: 'DRAFT' },
// ]
//
// export const PROPERTY_ACTIVITY_STATUS_FORM_OPTIONS: {
//   label: string
//   value: PropertyActivityStatus
// }[] = [
//   { label: 'Draft', value: 'DRAFT' },
//   { label: 'Published', value: 'PUBLISHED' },
// ]
